<template>
	<div class="agentinfo">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">代理管理</div>
					<div class="contentcard" v-if="!agent_id" style="text-align: center;">
						<p>代理ID有误，请从上级页面重新进入</p>
						<router-link to="agentlist">返回</router-link>
					</div>
					<div class="contentcard" v-else>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">用户ID</span>
							<span>{{agent_info.user_id}}</span>
						</div>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">微信昵称</span>
							<span>{{agent_info.nick_name}}</span>
						</div>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">微信头像</span>
							<img :src="agent_info.UIC_User.avatar_url" height="140" />
						</div>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">手机号码</span>
							<span>{{agent_info.phone_number}}</span>
						</div>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">等级</span>
							<a-select :defaultValue="agent_info.level" v-model="agent_info.level" style="width: 200px;">
								<a-select-option value="1">皇冠会员</a-select-option>
								<a-select-option value="2">钻石会员</a-select-option>
							</a-select>
						</div>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">上级代理</span>
							<!-- <span>{{agent_info.superior_id!==0?agent_info.superior_id:'无'}}</span> -->
							<a-input style="width: 200px;" v-model="agent_info.superior_id" placeholder="请输入上级ID" :disabled="agent_info.level=='1'" />
						</div>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">平台来源</span>
							<a-select :defaultValue="agent_info.user_from_platform" v-model="agent_info.user_from_platform" style="width: 200px;">
								<a-select-option :value="1">微信</a-select-option>
								<a-select-option :value="2">支付宝</a-select-option>
								<a-select-option :value="3">百度</a-select-option>
							</a-select>
						</div>
						<div style="margin-bottom: 5px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">来源app</span>
							<a-select :defaultValue="agent_info.user_from_app" v-model="agent_info.user_from_app" style="width: 200px;">
								<a-select-option v-for="(app,inde) in app_name" :key="inde" :value="app.id">{{app.app_name}}</a-select-option>
							</a-select>
						</div>
						<div style="margin-bottom: 15px;">
							<span style="display: inline-block;width: 200px;text-align: right;font-weight: 700;margin-right: 10px;">是否审核通过</span>
							<a-switch :defaultChecked="agent_info.reviewed" v-model="agent_info.reviewed">
								<a-icon type="check" slot="checkedChildren" />
								<a-icon type="close" slot="unCheckedChildren" />
							</a-switch>
						</div>
						<div style="text-align: center;">
							<a-button type="primary" size="small" style="width: 96px; font-size: 12px;" @click="submitbtn">确认</a-button>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>

	export default {

		data() {
			return {
				current: ['agentlist'],
				openKeys: ['agentmanagement'],
				agent_id: this.$route.query.agent_id || null,
				agent_info: [],
				app_name: {},

			}
		},
		created: function() {
			var self = this;
			var params = {
				agent_id: this.agent_id,
			};
			this.$axios.get('/agent/getone', {
				params: params
			}).then(function(res) {
				self.agent_info = res.data.agentinfo;
				self.app_name = res.data.appslist;

			});
		},
		methods: {
			submitbtn() {
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否保存代理信息修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						var params = {
							id: self.agent_id,
							user_id:self.agent_info.user_id,
							level: self.agent_info.level,
							user_from_platform: self.agent_info.user_from_platform,
							user_from_app: self.agent_info.user_from_app,
							reviewed: self.agent_info.reviewed,
						};
						if (params.level == '1') {
							params.superior_id = 0;
						}else{
							params.superior_id = self.agent_info.superior_id||0;
						}
						self.$axios.post('/agent/update', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
						})
					},
					onCancel() {},
				});
			}



		},

	};
</script>

<style>
	.agentinfo .contentcard {
		padding: 24px 50px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// index.vue?98639fdc